import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";

const AlertConfirmation = ({
  open,
  message = "Are you sure?",
  onConfirm,
  onCancel,
  cancelButton = "Cancel",
  confirmButton = "Confirm",
  isLoading = false,
  loadingMessage = "Loading...",
  maxWidth = "xs",
  fullWidth= true
}) => {
  let currentMessage = isLoading ? loadingMessage : message;

  return (
    <>
      <Dialog
        open={open}
        onClose={onCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={maxWidth}
        fullWidth={fullWidth}
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {currentMessage}
          </DialogContentText>
        </DialogContent>
        <div className="ui divider"></div>
        <DialogActions>
          <button
            type="button"
            onClick={onConfirm}
            className="ui primary button"
          >
            {confirmButton}
          </button>
          <button type="button" onClick={onCancel} className="ui button">
            {cancelButton}
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AlertConfirmation;
